module.exports = __webpack_public_path__ + "img/cs-baseIt-2.80d9abf5.jpg";